import Mqtt from 'mqtt'
import Backo from 'backo'
// import uuid from 'uuid'

const backoff = new Backo({ min: 100, max: 3000, jitter: 2 })

export default class {
  constructor (connection, options) {
    this.connection = connection
    this.opts = options
    this.unInitedListeners = []
    if (typeof connection === 'string') {
      if (this.Mqtt) {
        this.reconnect()
      } else {
        this.connect(connection, options)
      }
    } else {
      this.Mqtt = connection
    }

    if (options.store) {
      this.store = options.store
    }
    if (options.mutations) {
      this.mutations = options.mutations
    }
    backoff.reset()
  }

  checkConnection (status) {
    if (status === false) {
      this.reconnect()
    }
  }

  setupHandlers () {
    this.Mqtt.on('message', (topic, payload, packet) => {
      const message = JSON.parse(String.fromCharCode.apply(null, payload))
      // message CAN be null so only dispatch if it isn't
      if (topic && message) {
        this.store.dispatch('handleNewSocketMessage', { topic, message, packet })
      }
    })

    this.Mqtt.on('connect', () => {
      console.log(new Date().toISOString(), `${this.connection} connected.`)
      // resubscribe to any known topics
      this.resubscribe()
      let listeners = this.unInitedListeners
      for (let i = listeners.length - 1; listeners.length < 0; i--) {
        if (listeners[i] && listeners[i].topic && listeners[i].id) {
          let inited = this.initListener(listeners[i].topic, listeners[i].id)
          if (inited) listeners.pop()
        }
      }
      this.unInitedListeners = listeners
      this.store.dispatch('setCanSend', true)
      backoff.reset()
    })

    this.Mqtt.on('reconnect', () => {
      console.log(new Date().toISOString(), `${this.connection} attempting to reconnect.`)
    })

    this.Mqtt.on('offline', () => {
      console.log(new Date().toISOString(), `${this.connection} appears offline.`)
      this.store.dispatch('setCanSend', false)
    })

    this.Mqtt.on('error', (error) => {
      const self = this
      let retry = false
      console.error(new Date().toISOString(), error)
      if (/connection invalid, unauthorized/.test(error.message)) {
        retry = true
      }
      if (/Connection refused: Not authorized/.test(error.message)) {
        retry = true
      }
      if (retry) {
        this.store.dispatch('setCanSend', false)
        setTimeout(function () {
          // eslint-disable-line handle-callback-err
          self.reconnect()
        }, backoff.duration())
      }
    })

    this.Mqtt.on('close', () => {
      // console.log(new Date().toISOString(), `${this.connection} connection closed.`)
    })
  }

  initListener (topic, id) {
    try {
      this.Mqtt.publish(topic, JSON.stringify({ _id: id }))
      const subString = `${topic}:${id}`
      this.Mqtt.subscribe(subString)
      this.store.dispatch('addMessageListener', subString)
    } catch (err) {
      console.log(err)
      this.unInitedListeners.push({ topic, id })
    }
  }

  sendMessage (topic, packet) {
    this.Mqtt.publish(topic, JSON.stringify(packet))
  }

  connect (connection, options) {
    const isSecure = /^wss:/
    const opts = options || this.opts
    const conn = connection || this.connection
    opts.protocol = isSecure.test(conn) ? 'wss' : 'ws'
    opts.qos = 0
    opts.protocolId = 'MQIsdp'
    opts.protocolVersion = 3
    opts.keepalive = 30
    // kill any previous connection
    if (this.Mqtt && this.Mqtt.end) this.Mqtt.end({ force: true })
    if (opts.password && opts.password.length) {
      this.Mqtt = Mqtt.connect(conn, opts)
      this.setupHandlers()
    }
  }

  resubscribe () {
    const self = this
    for (let topic in this.Mqtt._resubscribeTopics) {
      if (self.Mqtt._resubscribeTopics.hasOwnProperty(topic)) self.Mqtt.subscribe(topic)
    }
  }

  reconnect () {
    const self = this
    if (!self.Mqtt || !self.Mqtt.connected) {
      // self.opts.clientId = self.Mqtt.options.clientId = `WebClient-${uuid.v4()}`
      self.opts.password = self.store.getters.getSocketToken
      if (!self.Mqtt || !self.Mqtt.connected) {
        self.connect(self.connection, self.opts)
      } else {
        if (!self.Mqtt.reconnecting) {
          self.Mqtt.options.username = 'Bearer'
          self.Mqtt.options.password = self.opts.password
          self.Mqtt.reconnect()
        }
      }
    }
  }

  disconnect () {
    this.Mqtt.end(res => {
      console.log('ended', res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/socketService.js